export default {
  API_ENDPOINT: "https://ancient-plateau-66272.herokuapp.com",
  TOKEN_KEY: "bashful-client-auth-token",
};
